import { useEffect, useState } from 'react'
import MuiBox from '@mui/material/Box'
import MuiIconButton from '@mui/material/IconButton'
import MuiTypography from '@mui/material/Typography'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'

import SectionDetail from './components/sectionDetail'
import SectionDrawer from './components/sectionDrawer'
import DeleteSection from './components/deleteSection'
import FieldDrawer from './components/fieldDrawer'
import DeleteField from './components/deleteField'

const Layout = ({ campaign }) => {
  const [showSectionDrawer, setShowSectionDrawer] = useState(false)
  const [deleteSectionDialogOpen, setDeleteSectionDialogOpen] = useState(false)
  const [sectionToDelete, setSectionToDelete] = useState(null)
  const [sectionToEdit, setSectionToEdit] = useState(null)
  const [selectedSection, setSelectedSection] = useState(null)
  const [showFieldDrawer, setShowFieldDrawer] = useState(false)
  const [deleteFieldDialogOpen, setDeleteFieldDialogOpen] = useState(false)
  const [fieldToEdit, setFieldToEdit] = useState(null)
  const [fieldToDelete, setFieldToDelete] = useState(null)

  useEffect(() => {
    if (sectionToDelete) {
      setDeleteSectionDialogOpen(true)
    }
  }, [sectionToDelete])

  useEffect(() => {
    if (sectionToEdit) {
      setShowSectionDrawer(true)
    }
  }, [sectionToEdit])

  useEffect(() => {
    if (!deleteSectionDialogOpen) {
      setSectionToDelete()
    }
  }, [deleteSectionDialogOpen])

  useEffect(() => {
    if (!showSectionDrawer) {
      setSectionToEdit()
    }
  }, [showSectionDrawer])

  useEffect(() => {
    if (fieldToEdit) {
      setShowFieldDrawer(true)
    }
  }, [fieldToEdit])

  useEffect(() => {
    if (fieldToDelete) {
      setDeleteFieldDialogOpen(true)
    }
  }, [fieldToDelete])

  useEffect(() => {
    if (!deleteFieldDialogOpen) {
      setFieldToDelete()
    }
  }, [deleteFieldDialogOpen])

  useEffect(() => {
    if (!showFieldDrawer) {
      setFieldToEdit()
    }
  }, [showFieldDrawer])

  return (
    <>
      <SectionDrawer
        campaign={campaign}
        section={sectionToEdit}
        showDrawer={showSectionDrawer}
        setShowDrawer={setShowSectionDrawer}
      />
      <FieldDrawer
        campaign={campaign}
        section={selectedSection}
        field={fieldToEdit}
        showDrawer={showFieldDrawer}
        setShowDrawer={setShowFieldDrawer}
      />
      <MuiBox sx={{ display: 'flex', alignItems: 'center' }}>
        <MuiTypography variant="h6">LAYOUT SECTIONS</MuiTypography>
        {campaign?.id && (
          <MuiIconButton onClick={() => setShowSectionDrawer(true)}>
            <AddCircleOutlineIcon />
          </MuiIconButton>
        )}
      </MuiBox>

      <MuiBox
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
        }}
      >
        {!campaign?.layout?.sections?.length && (
          <MuiTypography>No sections added yet. Add one by clicking the Add icon above.</MuiTypography>
        )}
        {campaign?.layout?.sections
          ?.slice()
          ?.sort((a, b) => a.priority - b.priority)
          ?.map((section) => (
            <SectionDetail
              key={section.id}
              section={section}
              setSectionToEdit={setSectionToEdit}
              setSectionToDelete={setSectionToDelete}
              setSelectedSection={setSelectedSection}
              setFieldToEdit={setFieldToEdit}
              setFieldToDelete={setFieldToDelete}
            />
          ))}
      </MuiBox>
      <DeleteSection
        campaign={campaign}
        section={sectionToDelete}
        open={deleteSectionDialogOpen}
        setOpen={setDeleteSectionDialogOpen}
      />
      <DeleteField
        campaign={campaign}
        section={selectedSection}
        field={fieldToDelete}
        open={deleteFieldDialogOpen}
        setOpen={setDeleteFieldDialogOpen}
      />
    </>
  )
}

export default Layout
